export default __webpack_public_path__ + "static/media/Scholar's Grasp of the Crescent.dd681157.jpg";